import { render, staticRenderFns } from "./TearDownAndInstallOrderApprove.vue?vue&type=template&id=059d86c5&scoped=true"
import script from "./TearDownAndInstallOrderApprove.vue?vue&type=script&lang=js"
export * from "./TearDownAndInstallOrderApprove.vue?vue&type=script&lang=js"
import style0 from "./TearDownAndInstallOrderApprove.vue?vue&type=style&index=0&id=059d86c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d86c5",
  null
  
)

export default component.exports